import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xl-9 order-2 order-xl-1" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white checkout-box letter-spacing" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs bg-white border-0 rounded-0",
  id: "myTab",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100 active",
      id: "basic-information-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#basic-information-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "basic-information-tab-pane",
      "aria-selected": "true"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-fingerprint-scan" }),
      /*#__PURE__*/_createTextVNode(" General ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
      id: "contact-information-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#contact-information-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "contact-information-tab-pane",
      "aria-selected": "false"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-phone-call" }),
      /*#__PURE__*/_createTextVNode(" Contacto ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
      id: "parents-guardians-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#parents-guardians-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "parents-guardians-tab-pane",
      "aria-selected": "false"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-users-group" }),
      /*#__PURE__*/_createTextVNode(" Padres ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
      id: "academic-information-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#academic-information-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "academic-information-tab-pane",
      "aria-selected": "false"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-student-with-graduation-cap" }),
      /*#__PURE__*/_createTextVNode(" Académico ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
      id: "health-welfare-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#health-welfare-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "health-welfare-tab-pane",
      "aria-selected": "false"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-industry" }),
      /*#__PURE__*/_createTextVNode(" Salud ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
      id: "additional-contacts-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#additional-contacts-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "additional-contacts-tab-pane",
      "aria-selected": "false"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user" }),
      /*#__PURE__*/_createTextVNode(" Emergencia ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
      id: "transportation-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#transportation-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "transportation-tab-pane",
      "aria-selected": "false"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-express-delivery" }),
      /*#__PURE__*/_createTextVNode(" Transporte ")
    ])
  ])
], -1)
const _hoisted_7 = {
  class: "tab-content p-15 p-sm-20 p-md-25 p-lg-30",
  id: "myTabContent"
}
const _hoisted_8 = {
  class: "tab-pane fade show active",
  id: "basic-information-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_9 = {
  class: "tab-pane fade",
  id: "contact-information-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_10 = {
  class: "tab-pane fade",
  id: "parents-guardians-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_11 = {
  class: "tab-pane fade",
  id: "academic-information-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_12 = {
  class: "tab-pane fade",
  id: "health-welfare-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_13 = {
  class: "tab-pane fade",
  id: "additional-contacts-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_14 = {
  class: "tab-pane fade",
  id: "transportation-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_15 = { class: "d-flex align-items-center flex-wrap gap-2" }
const _hoisted_16 = { class: "d-flex align-items-center gap-2 flex-wrap" }
const _hoisted_17 = { class: "ms-auto" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, "Cancelar", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card" }, null, -1)
const _hoisted_20 = { class: "col-lg-5 col-xl-3" }
const _hoisted_21 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box" }
const _hoisted_22 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_23 = { class: "profile-info d-sm-flex align-items-center" }
const _hoisted_24 = {
  class: "position-relative w-100",
  style: {"max-width":"280px"}
}
const _hoisted_25 = { class: "ratio ratio-1x1 rounded-circle overflow-hidden shadow-sm" }
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  for: "avatar-file",
  class: "btn btn-light border position-absolute d-flex align-items-center justify-content-center shadow file-upload text-center bg-white rounded-circle text-primary",
  style: {"width":"2px !important","height":"42px !important","right":"6px","bottom":"10px","z-index":"2","cursor":"pointer"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "flaticon-add-photo",
    style: {"font-size":"25px"}
  })
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "border-top mt-15 mb-15 mt-sm-20 mb-sm-20 mt-md-25 mb-md-25 mt-lg-30 mb-lg-30" }, null, -1)
const _hoisted_29 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_30 = { class: "fw-medium text-black-emphasis mb-0" }
const _hoisted_31 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_32 = { class: "title mt-12 mt-sm-0" }
const _hoisted_33 = { class: "d-block fs-md-15 fs-lg-16 text-dark-emphasis mb-8" }
const _hoisted_34 = { class: "d-block fw-bold text-primary" }
const _hoisted_35 = { class: "info mt-25 ps-0 mb-0 list-unstyled" }
const _hoisted_36 = { class: "position-relative" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-info rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-edit" })
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "# Registro único", -1)
const _hoisted_39 = {
  href: "tel:+1-321-456-8756",
  class: "d-inline-block fs-md-15 fs-lg-16 text-muted text-decoration-none"
}
const _hoisted_40 = { class: "position-relative" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-success rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-mail-inbox-app" })
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Correo electrónico", -1)
const _hoisted_43 = {
  href: "mailto:johnathon23@gmail.com",
  class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none"
}
const _hoisted_44 = { class: "position-relative" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-info rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-telephone-call" })
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Telefono", -1)
const _hoisted_47 = {
  href: "tel:+1-321-456-8756",
  class: "d-inline-block fs-md-15 fs-lg-16 text-muted text-decoration-none"
}
const _hoisted_48 = { class: "position-relative" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-warning rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-industry" })
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "EPS", -1)
const _hoisted_51 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_52 = { class: "position-relative" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-info rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-employee" })
], -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, " Padre ", -1)
const _hoisted_55 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_56 = { class: "position-relative" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-info rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-employee" })
], -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, " Madre ", -1)
const _hoisted_59 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_60 = { class: "position-relative" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-info rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-date-1" })
], -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, " Ultima fecha de matricula ", -1)
const _hoisted_63 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_64 = { class: "position-relative" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-warning rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-status" })
], -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, " Estado ", -1)
const _hoisted_67 = { class: "badge text-outline-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PersonelInformationComponent = _resolveComponent("PersonelInformationComponent")!
  const _component_TabContactComponent = _resolveComponent("TabContactComponent")!
  const _component_TabParentsComponent = _resolveComponent("TabParentsComponent")!
  const _component_TabAcademicComponent = _resolveComponent("TabAcademicComponent")!
  const _component_TabHealthComponent = _resolveComponent("TabHealthComponent")!
  const _component_TabEmergencyComponent = _resolveComponent("TabEmergencyComponent")!
  const _component_TabTransportComponent = _resolveComponent("TabTransportComponent")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_container = _resolveComponent("b-container")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_b_form, {
              ref: "formRecord",
              id: "formModal",
              novalidate: "",
              onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_container, { fluid: "" }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_PersonelInformationComponent, {
                          record: _ctx.form.record,
                          "onUpdate:record": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.record) = $event)),
                          ref: "personRef",
                          wasValidated: _ctx.wasValidated
                        }, null, 8, ["record", "wasValidated"])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_TabContactComponent, {
                          record: _ctx.form.record,
                          "onUpdate:record": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.record) = $event)),
                          ref: "contactRef",
                          wasValidated: _ctx.wasValidated
                        }, null, 8, ["record", "wasValidated"])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_TabParentsComponent, {
                          record: _ctx.form.record,
                          "onUpdate:record": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.record) = $event)),
                          ref: "parentRef",
                          wasValidated: _ctx.wasValidated
                        }, null, 8, ["record", "wasValidated"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_TabAcademicComponent, {
                          record: _ctx.form.record,
                          "onUpdate:record": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.record) = $event)),
                          ref: "academicRef",
                          wasValidated: _ctx.wasValidated
                        }, null, 8, ["record", "wasValidated"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_TabHealthComponent, {
                          record: _ctx.form.record,
                          "onUpdate:record": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.record) = $event)),
                          ref: "healthRef",
                          wasValidated: _ctx.wasValidated
                        }, null, 8, ["record", "wasValidated"])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_TabEmergencyComponent, {
                          record: _ctx.form.record,
                          "onUpdate:record": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.record) = $event)),
                          ref: "emergencyRef",
                          wasValidated: _ctx.wasValidated
                        }, null, 8, ["record", "wasValidated"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_TabTransportComponent, {
                          record: _ctx.form.record,
                          "onUpdate:record": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.record) = $event)),
                          ref: "transportRef",
                          wasValidated: _ctx.wasValidated
                        }, null, 8, ["record", "wasValidated"])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_b_button, {
                            class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                            type: "submit"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.form.record.Id ? 'Guardar cambios' : 'Agregar estudiante'), 1)
                            ]),
                            _: 1
                          }),
                          (_ctx.form.record.Id > 0)
                            ? (_openBlock(), _createBlock(_component_b_button, {
                                key: 0,
                                class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-info",
                                type: "button",
                                onClick: _ctx.printReport
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" IMPRIMIR PREINSCRIPCIÓN ")
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_b_button, {
                            onClick: _ctx.cancel,
                            class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_18
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ])
        ])
      ]),
      _hoisted_19
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("img", {
                  src: _ctx.previewUrl,
                  alt: "Foto",
                  class: "w-100 h-100 object-fit-cover d-block"
                }, null, 8, _hoisted_26)
              ]),
              _createElementVNode("input", {
                id: "avatar-file",
                type: "file",
                accept: "image/*",
                class: "visually-hidden",
                onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
              }, null, 32),
              _hoisted_27
            ])
          ]),
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("h6", _hoisted_30, _toDisplayString(`${_ctx.form.record?.Name || ''} ${_ctx.form.record?.LastName ||
              ''}`), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("span", _hoisted_33, [
                _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.enrollment?.CourseGroupName), 1)
              ])
            ])
          ]),
          _createElementVNode("ul", _hoisted_35, [
            _createElementVNode("li", _hoisted_36, [
              _hoisted_37,
              _hoisted_38,
              _createElementVNode("a", _hoisted_39, _toDisplayString(_ctx.form.record?.SequenceNum || ''), 1)
            ]),
            _createElementVNode("li", _hoisted_40, [
              _hoisted_41,
              _hoisted_42,
              _createElementVNode("a", _hoisted_43, _toDisplayString(_ctx.form.record?.InstitucionalEmail || _ctx.form.record?.PersonalEmail), 1)
            ]),
            _createElementVNode("li", _hoisted_44, [
              _hoisted_45,
              _hoisted_46,
              _createElementVNode("a", _hoisted_47, _toDisplayString(_ctx.form.record?.PrimaryPhone || _ctx.form.record?.SecondaryPhone), 1)
            ]),
            _createElementVNode("li", _hoisted_48, [
              _hoisted_49,
              _hoisted_50,
              _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.form.record?.NameIps || ''), 1)
            ]),
            _createElementVNode("li", _hoisted_52, [
              _hoisted_53,
              _hoisted_54,
              _createElementVNode("span", _hoisted_55, _toDisplayString(`${_ctx.form.record?.FatherName || ''}
                ${_ctx.form.record?.FatherPhonePersonal || ''}`), 1)
            ]),
            _createElementVNode("li", _hoisted_56, [
              _hoisted_57,
              _hoisted_58,
              _createElementVNode("span", _hoisted_59, _toDisplayString(`${_ctx.form.record?.MotherName || ''}
                ${_ctx.form.record?.MotherPhonePersonal || ''}`), 1)
            ]),
            _createElementVNode("li", _hoisted_60, [
              _hoisted_61,
              _hoisted_62,
              _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.enrollment?.EnrollmentDate?.substring(0, 10) || ''), 1)
            ]),
            _createElementVNode("li", _hoisted_64, [
              _hoisted_65,
              _hoisted_66,
              _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.enrollment?.Status || 'MATRICULA PENDIENTE'), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}